import { faPaw } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";
import CatalogImage from "common/components/CatalogImage";

import Switch from "client/common/components/inputs/Switch";

import { DosageReminderItem, DosageReminderPatient } from "../types";
import { SPECIES_ICONS } from "../constants";

import styles from "../styles/ItemSummary.module.less";

type ItemSummaryProps = {
  patient: DosageReminderPatient;
  item: DosageReminderItem;
  isActive: boolean;
  /** Shows Enable/Disable switch for Edit page */
  onActiveChange: ((isActive: boolean) => void) | null;
};

const ItemSummary = ({ patient, item, isActive, onActiveChange }: ItemSummaryProps) => {
  const productName = item.product.product_line.name;

  return (
    <div className={styles.summary}>
      <CatalogImage
        image={item.image}
        size="thumbnail"
        alt={productName}
        className={styles.image}
      />
      <div className={styles.details}>
        <span className={styles.name}>{productName}</span>
        <span className={styles.variant}>
          {item.product.name} · {item.name}
        </span>
        <span className={styles.patient}>
          <Icon icon={SPECIES_ICONS[patient.species] ?? faPaw} />
          <span className={styles.patientName}>For {patient.name}</span>
        </span>
      </div>
      {onActiveChange && (
        <div className={styles.action}>
          <Switch
            value={isActive}
            onChange={onActiveChange}
            label={`Reminders for ${patient.name}`}
          />
        </div>
      )}
    </div>
  );
};

export default ItemSummary;
